/* @flow */

import React from "react";
import cn from "classnames";
import { useTranslate } from "@awardit/react-use-translate";

import styles from "./styles.scss";

type Props = {
  className?: string,
};

const Logo = ({ className, ...props }: Props): React$Node => {
  const t = useTranslate();

  return (
    <div {...props} className={cn(styles.logo, className)}>
      <img
        alt={t("LOGO.ALT")}
        aria-label={t("LOGO.TITLE")}
        src="/assets/logo.png"
        className={styles.logoMain}
      />
    </div>
  );
};

export default Logo;
